import { WordCloud } from '@/word-cloud/interfaces';

export enum Layouts {
    Compact = 'compact',
    Expanded = 'expanded',
    Display = 'display'
}

export const LAYOUT_SET: Record<Layouts | string, WordCloud.ConstantSet> = {
    [Layouts.Display]: {
        SIZE_RANGE: [24, 48],
        RECT_PADDING: { X: 8, Y: 4 },
        LAYOUT_PADDING: 7,
        FONT_SCALE_EXPONENT: 1.5,
        MAX_WORDS: 60,
        ROTATE_ACCESSOR: 0,
        SPIRAL: 'archimedean',
        WIDTH_TRANSFORMER: (width: number) => width,
    },
    [Layouts.Compact]: {
        SIZE_RANGE: [9, 18],
        RECT_PADDING: { X: 4, Y: 4 },
        LAYOUT_PADDING: 9,
        FONT_SCALE_EXPONENT: 1,
        MAX_WORDS: 25,
        ROTATE_ACCESSOR: () => ~~(Math.random() * 3 - 1) * 90,
        SPIRAL: 'rectangular',
        WIDTH_TRANSFORMER: (width: number) => width * 1.5,
    },
    [Layouts.Expanded]: {
        SIZE_RANGE: [9, 18],
        RECT_PADDING: { X: 4, Y: 4 },
        LAYOUT_PADDING: 6,
        FONT_SCALE_EXPONENT: 1,
        MAX_WORDS: 40,
        ROTATE_ACCESSOR: () => ~~(Math.random() * 3 - 1) * 90,
        SPIRAL: 'archimedean',
        WIDTH_TRANSFORMER: (width: number) => width,
    }
};

export const MAX_DRAW_TIME = 400;
export const REDRAW_INTERVAL = 6000;
export const FIX_RECT_INTERVAL = 1000;
